import { Component, OnInit, Inject } from '@angular/core';
import { IPRUpdatesModel } from '../../../../Models/IPRUpdatesModel';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { AppConfig } from '../../../../Services/app.config';
import { CheckAuth } from '../../../../Services/utility.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ToolEnum } from 'src/Models/Common';
import { iprupdatesService } from 'src/Services/frontiprupdatesService';
import { IPRstateMasterModel } from 'src/Models/IprstateMasterModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ipr-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.css']
})
export class IPRMyFavoritesComponent implements OnInit {
  userID: number = 0;
  appModel: any;
  isloading: boolean = false;
  tokenKey: string = '';
  favouriteCarrierModel: IPRUpdatesModel[] = [];
  favouriteStateModel: IPRstateMasterModel[] = [];
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  carrierForm: FormGroup;
  baseUrl: string;

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';

  dropdownListProviders = [];
  dropdownSettingsProviders = {};
  selectedItemsProviders = [];
  listOfstateID: string[] = [];
  ClientSelectedTool: string;
  ValidationMessage: string;
  DeSelectedFavoriteId: number;
  FavoriteType: string;
  IsDeselected: number = 0;
  isStateRecordsExists: boolean = true;
  isProviderRecordsExists: boolean = true;
  productId: number;
  iprUnreadflag: boolean = true;
  iprUnread: number = 0;

  constructor(@Inject('BASE_URL') baseUrl: string,
    private readonly iprupdatesService: iprupdatesService,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');

    this.appModel = AppConfig.settings.ConnectionStrings;
    this.productId = ToolEnum.ipr;
    this.titleService.setTitle('My Favorites | JSi360');

    this.carrierForm = new FormGroup({
      stateId: new FormControl(),
      carrierId: new FormControl(),
    });

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');

    this.iprUnreadflag = true;
    let iprReadflag = sessionStorage.getItem('iprUnreadflag');
    this.iprUnreadflag = iprReadflag === 'true' ? true : false;

    let iprUnreadcount = sessionStorage.getItem('iprUnread');

    this.iprUnread = parseInt(iprUnreadcount);

    this.movetotop();
    this.isloading = false;
    this.GetClientFavorites();
    this.GetCarriers();
    this.GetStateData();
  }

  ngOnInit() {

  }

  GetCarriers(): void {
    this.isloading = true;

    this.iprupdatesService.GetCarriers(this.tokenKey, '', '', '1,0', 'BusinessName', '', this.userID, 0, '').subscribe(
      data => {
        if (data["updates"] != null) {
          this.selectedItemsProviders = [];
          for (let iCounter = 0; iCounter < data["updates"].length; iCounter++) {
            this.dropdownListProviders.push(
              { "id": data["updates"][iCounter].carrierId, "itemName": data["updates"][iCounter].businessName }
            );
            if (data["updates"][iCounter].favourite == "1")
              this.selectedItemsProviders.push({ "id": data["updates"][iCounter].carrierId, "itemName": data["updates"][iCounter].businessName });
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsProviders = {
          singleSelection: false,
          text: "Select Provider(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen providerclass",
          badgeShowLimit: 1,
          noDataLabel: 'No Provider available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: false
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetStatesByUserID(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          this.selectedItemsState = [];
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );

            if (data["state"][iCounter].favourite == "1")
              this.selectedItemsState.push({ "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name });
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select State(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: true
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  GetClientFavorites(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.GetClientFavorites(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["clientfavorites"] != null) {
          this.favouriteCarrierModel = data["clientfavorites"][0].listOfCarriers;
          this.favouriteStateModel = data["clientfavorites"][0].listOfStates;

          if (this.favouriteStateModel == null)
            this.isStateRecordsExists = false;
          else
            this.isStateRecordsExists = true;

          if (this.favouriteCarrierModel == null)
            this.isProviderRecordsExists = false;
          else
            this.isProviderRecordsExists = true;
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  // State ---------------------------
  OnSelectState($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteState($event['id'], 1);
  }
  OnDeSelectState($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteState($event['id'], 0);
  }

  onSelectAllStateList($event) {
    let stateIds: string = '';
    if ($event) {
      $event.map(x => {
        stateIds += String(x.id) + ',';
      });
      stateIds += "-99";
    }
    this.IsDeselected = 0;
    this.SaveFavoriteState(stateIds, 1);
  }

  onDeSelectAllStateList($event) {
    if (this.favouriteStateModel != null) {
      let stateIds: string = '';
      this.favouriteStateModel.forEach(x => {
        stateIds += String(x.stateId) + ',';
      });
      stateIds += "-99";
      this.IsDeselected = 0;
      this.SaveFavoriteState(stateIds, 0);
    }
  }

  SaveFavoriteState(ids: string, IsFavorite: number) {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    this.iprupdatesService.ClientStateFavouriteAdd(this.tokenKey, this.userID, ids, IsFavorite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite == 1)
            this.showMessage('Selected state added successfully to favorite list.', 'Favorite', 'success');
          else
            this.showMessage('Selected state removed successfully from favorite list.', 'Favorite', 'success');
          this.GetClientFavorites();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  DeselectFavourite() {
    this.IsDeselected = 0;
    document.getElementById("btnClose").click();
    if (this.FavoriteType == 'state') {
      this.SaveFavoriteState(String(this.DeSelectedFavoriteId), 0);
      this.selectedItemsState = this.removeElemetninArray(this.selectedItemsState, this.DeSelectedFavoriteId);
    }
    else {
      this.SaveFavoriteProvider(this.DeSelectedFavoriteId, 0);
      this.selectedItemsProviders = this.removeElemetninArray(this.selectedItemsProviders, this.DeSelectedFavoriteId);
    }
  }

  CancelDeselectFavourite() {
    if (this.FavoriteType == 'state' && this.IsDeselected == 1) {
      this.selectedItemsState.push({ "id": this.DeSelectedFavoriteId });
    }
    else if (this.FavoriteType == 'provider' && this.IsDeselected == 1) {
      this.selectedItemsProviders.push({ "id": this.DeSelectedFavoriteId });
    }
  }
  // State ---------------------------

  // Provider ------------------------
  OnSelectProvider($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteProvider($event['id'], 1);
  }
  OnDeSelectProvider($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteProvider($event['id'], 0);
  }
  SaveFavoriteProvider(id: number, IsFavorite: number) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.iprupdatesService.ClientCarrierFavouriteAdd(this.tokenKey, this.userID, id, IsFavorite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite == 1)
            this.showMessage('Selected provider added successfully to favorite list.', 'Favorite', 'success');
          else
            this.showMessage('Selected provider removed successfully from favorite list.', 'Favorite', 'success');
          this.GetClientFavorites();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }
  // Provider ------------------------

  RemoveStarFavorite(id: number, Type: string) {
    this.IsDeselected = 1;
    this.DeSelectedFavoriteId = id;
    if (Type == 'state') {
      this.ValidationMessage = "Are you sure you want to remove selected state from favorite list?"
      this.FavoriteType = 'state';
    }
    else {
      this.ValidationMessage = "Are you sure you want to remove selected provider from favorite list?"
      this.FavoriteType = 'provider';
    }
    var elem = document.getElementById("lnkFavouriteValidation");
    elem.click();
  }
  removeElemetninArray(array, element) {
    return array.filter(e => e.id != element);
  }
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }
}
